"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    card: {
        marginBottom: theme.spacing() * 2,
        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing() * 2,
            marginBottom: 0
        }
    },
    cardContent: {
        paddingLeft: theme.spacing() * 3,
        paddingRight: theme.spacing() * 3,
        paddingBottom: '16px !important',
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column'
        }
    },
    winningNumbers: {
        marginRight: theme.spacing()
    },
    cardRow: {
        display: 'flex',
        alignItems: 'center',
        paddingTop: theme.spacing() + 4
    },
    cardRowBody: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap'
    },
    cardRowSpacing: {
        paddingRight: theme.spacing(),
        paddingLeft: theme.spacing()
    },
    noDrawsContainer: {
        display: 'flex',
        margin: 40,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    },
    noDrawsIcon: {
        fontSize: 64,
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(2)
    },
    heading: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        height: 60,
        marginTop: theme.spacing(2)
    },
    centered: {
        display: 'flex',
        justifyContent: 'center'
    },
    rightSide: {
        display: 'flex',
        justifyContent: 'right'
    },
    dropdownStyle: {
        width: '100px',
        [theme.breakpoints.down('sm')]: {
            width: '100px'
        }
    },
    btnStyle: {
        paddingTop: theme.spacing() + 2,
        paddingBottom: theme.spacing() + 2,
        paddingLeft: theme.spacing(2) + 4,
        paddingRight: theme.spacing(2) + 4
    },
    selectLabel: {
        borderBottom: 0,
        paddingLeft: theme.spacing() + 4,
        paddingTop: theme.spacing() + 2,
        paddingBottom: theme.spacing() + 2
    },
    iframe: {
        height: '100%',
        width: '100%',
        maxWidth: '100%',
        paddingTop: theme.spacing() + 1,
        paddingBottom: theme.spacing() + 1,
        [theme.breakpoints.down('md')]: {
            height: '100%',
            width: '100%',
            maxWidth: '100%',
            margin: 0,
            maxHeight: '95%',
            position: 'absolute'
        },
        border: 0
    },
    rowsPerPageGrid: {
        marginRight: 0,
        marginLeft: 'auto',
        whiteSpace: 'nowrap',
        '@media (max-width:600px)': {
            minWidth: '150px',
            marginRight: 'auto'
        }
    },
    paginationGrid: {
        float: 'left',
        width: '100%',
        '@media (max-width:600px)': {
            height: '20px',
            paddingTop: '50px'
        }
    },
    visibilitySD: {
        '@media (max-width:600px)': {
            display: 'block',
            float: 'left',
            paddingRight: '30px',
            paddingTop: '20px'
        },
        '@media (min-width:600px)': {
            display: 'none'
        }
    },
    visibilityBD: {
        '@media (max-width:600px)': {
            display: 'none'
        },
        '@media (min-width:600px)': {
            display: 'flex'
        }
    },
    gameDetailsDateSD: {
        paddingTop: '17px',
        minWidth: '100px'
    },
    gameDetailsRevealWatchSD: {
        '@media (max-width:600px)': {
            float: 'left',
            paddingLeft: '100px'
        }
    },
    gameDetailsRevealSD: {
        '@media (max-width:600px)': {
            paddingLeft: '70px',
            paddingTop: '10px'
        }
    },
    gameDetailsWinningInfoSD: {
        '@media (max-width:600px)': {
            width: '20px'
        }
    },
    gameDetailsDrawDateSD: {
        '@media (max-width:600px)': {
            paddingTop: '15px'
        }
    },
    gameDetailsDataRevealedSD: {
        '@media (max-width:600px)': {
            paddingTop: '15px',
            paddingLeft: '40px'
        }
    },
    gameDetailsDataRevealedFontSD: {
        '@media (max-width:600px)': {
            fontSize: '12px',
            paddingLeft: '60px'
        }
    },
    gameDetailsDataRevealedFontSDHighlight: {
        color: theme.palette.success.main
    },
    gameDetailsDataRevealedFontOTWSD: {
        '@media (max-width:600px)': {
            paddingLeft: '60px'
        }
    }
});
exports.default = styles;
//# sourceMappingURL=GameTableStyle.js.map